import { Box, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { RequestedFieldValue as RequestedFieldValueSlot } from "./share-link-fields-slot-definitions"
import { isKnownRequestedFieldType } from "./requested-field-types"
import { TextFieldValue } from "./text-field-value"

/**
 * Read-only HOST for one requested field's answer on the internal reviewer's regime "Responses" tab.
 * Renders the shared chrome (the `field.label` inside a `data-cy="requested-field-value-<id>"` wrapper)
 * and delegates the value display to the `RequestedFieldValue` slot subtype for `field.type`. Each type
 * self-registers a plug in `share-link-fields.runtime.js` — this is the read-only mirror of
 * `requested-field-input.js`, using the same slot-subtype dispatch instead of a `<Switch>`.
 *
 * Unknown / legacy field types have no plug; for those we render the generic `<TextFieldValue>` as the
 * slot's default child. Known types render their plug only — the host passes no default child for them
 * so the plug and a fallback never both render (slot children render alongside matched plugs). The
 * per-type renderers (and `TextFieldValue`) each show the muted placeholder when their value is empty.
 *
 * @param {object} props
 * @param {{ id: string, type: string, label: string, options?: Array, currencyCode?: string }} props.field
 * @param {*} [props.value] the recipient's answer for this field
 */
export function RequestedFieldValue({ field, value }) {
    if (!field?.id) return null

    return (
        <Box data-cy={`requested-field-value-${field.id}`}>
            <Stack spacing={0.25}>
                <Typography variant="caption" color="text.secondary">
                    {field.label}
                </Typography>
                <RequestedFieldValueSlot.Slot type={field.type} field={field} value={value}>
                    <If value={!isKnownRequestedFieldType(field.type)}>
                        <TextFieldValue field={field} value={value} />
                    </If>
                </RequestedFieldValueSlot.Slot>
            </Stack>
        </Box>
    )
}
